"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { ArrowRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const agents = [{
  name: "Anish Patel, MBA",
  role: "REALTOR",
  roleAccentColor: "var(--accent-gold)",
  subtitle: "Realtor",
  bio: "Helping buyers find more home, better value, and a smoother path to homeownership across Chicago’s western suburbs.",
  email: "anish@propvault.com",
  phone: "(630) 555-0123",
  location: "Aurora, IL",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/Hero Image.png",
  logoUrl: "/img/dream_realty_logo.png"
}, {
  name: "Manish Shah",
  role: "MLO / OWNER",
  roleAccentColor: "var(--primary)",
  subtitle: "Loan Officer",
  bio: "I make the loan process simple, clear, and stress-free so you can focus on finding the perfect home.",
  email: "manish@propvault.com",
  phone: "(630) 555-0124",
  location: "Plainfield, IL",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/Screenshot 2026-05-09 at 3.36.25 PM.png",
  nmls: "NMLS #1234567",
  logoUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/genex_lending_logo.png"
}];
export default function AgentProfiles() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="agent-profiles" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 md:mb-16 text-center max-w-3xl mx-auto">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 tracking-tight">Guidance Every Step of the Way</h2>
          <p className="text-muted-foreground text-lg md:text-xl">Buying a home can feel overwhelming. We’re here to simplify the process and help you explore your options with confidence.</p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-0 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {agents.map((agent, i) => <Card data-index={i} key={i} className={`overflow-hidden border-none shadow-none bg-card group rounded-lg ${i === 0 ? "lg:border-r lg:border-border/50 lg:rounded-r-none" : "lg:rounded-l-none"}`}>
              <CardContent className="p-6 sm:p-8 flex flex-col sm:flex-row gap-6 sm:gap-8 items-center sm:items-start text-center sm:text-left h-full">
                <SafeHydrate><Avatar className="size-28 sm:size-32 shrink-0 border-4 border-background shadow-sm ring-1 ring-border/50 group-hover:ring-primary/30 transition-all duration-300 rounded-lg">
                  <AvatarImage src={agent.image} data-wvc-srcset={`${agent.image}-wvc-srcset`} data-wvc-sizes={`${agent.image}-wvc-sizes`} alt={`Portrait of ${agent.name}`} className="object-cover object-top" />
                  <AvatarFallback className="font-default text-3xl bg-primary/10 text-primary font-semibold rounded-lg">
                    {agent.name.charAt(0)}
                  </AvatarFallback>
                </Avatar></SafeHydrate>
                
                <div className="flex flex-col flex-1 h-full">
                  <div>
                    <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2">
                      <span className="inline-block px-2.5 py-0.5 rounded-md text-[10px] font-bold uppercase tracking-widest text-white w-fit mx-auto sm:mx-0" style={{
                    backgroundColor: agent.roleAccentColor
                  }}>
                        {agent.role}
                      </span>
                      {agent.nmls && <span className="text-[10px] text-muted-foreground font-medium uppercase tracking-wider">
                          {agent.nmls}
                        </span>}
                    </div>
                    
                    <h3 className="font-default text-2xl font-bold text-foreground tracking-tight">
                      {agent.name}
                    </h3>
                    
                    <p className="text-primary font-semibold text-sm mt-1 mb-3">
                      {agent.subtitle}
                    </p>
                    
                    <p className="text-muted-foreground text-sm leading-relaxed mb-6">
                      {agent.bio}
                    </p>
                  </div>
                  
                  
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}